import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Box, FormControl, Checkbox } from '@primer/react';

var CheckboxWrapper = {
  display: "flex",
  borderColor: "border.default",
  marginTop: "0px",
  "&:checked, &:indeterminate": {
    backgroundColor: "checked.bg.checked",
    borderColor: "checked.bg.checked",
    alignItems: "center"
  }
};
var visuallyHiddenStyle = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  border: 0
};
var LTCheckbox = function LTCheckbox(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? undefined : _b,
    _c = _a.checked,
    checked = _c === void 0 ? false : _c,
    _d = _a.className,
    className = _d === void 0 ? "" : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.labelStyle,
    labelStyle = _f === void 0 ? {} : _f,
    _g = _a.id,
    id = _g === void 0 ? undefined : _g,
    _h = _a.indeterminate,
    indeterminate = _h === void 0 ? false : _h,
    _j = _a.label,
    label = _j === void 0 ? null : _j,
    _k = _a.leadingIcon,
    leadingIcon = _k === void 0 ? null : _k,
    _l = _a.onChange,
    onChange = _l === void 0 ? function () {} : _l,
    _m = _a.onClick,
    onClick = _m === void 0 ? function () {} : _m,
    _o = _a.onKeyDown,
    onKeyDown = _o === void 0 ? function () {} : _o,
    _p = _a.shouldHighlightLabel,
    shouldHighlightLabel = _p === void 0 ? false : _p,
    _q = _a.style,
    style = _q === void 0 ? {} : _q,
    _r = _a.trailingIcon,
    trailingIcon = _r === void 0 ? null : _r,
    _s = _a.value,
    value = _s === void 0 ? "" : _s,
    _t = _a.visuallyHidden,
    visuallyHidden = _t === void 0 ? false : _t,
    rest = __rest(_a, ["ariaLabel", "checked", "className", "disabled", "labelStyle", "id", "indeterminate", "label", "leadingIcon", "onChange", "onClick", "onKeyDown", "shouldHighlightLabel", "style", "trailingIcon", "value", "visuallyHidden"]);
  var handleChange = function handleChange(event) {
    onChange(event.target.checked, value, event);
  };
  var labelFontWeight = shouldHighlightLabel ? checked ? 600 : 400 : 400;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    disabled: disabled,
    sx: {
      alignItems: "center"
    },
    id: id
  }, /*#__PURE__*/React.createElement(Checkbox, __assign({
    "aria-label": ariaLabel,
    "aria-checked": checked,
    checked: checked,
    className: className,
    indeterminate: indeterminate,
    onChange: handleChange,
    onClick: onClick,
    onKeyDown: onKeyDown,
    sx: __assign(__assign({}, CheckboxWrapper), style),
    value: value
  }, rest)), /*#__PURE__*/React.createElement(FormControl.Label, {
    "for": id,
    sx: __assign(__assign({
      alignItems: "center",
      display: "flex",
      gap: "8px",
      fontWeight: labelFontWeight
    }, visuallyHidden && visuallyHiddenStyle), labelStyle)
  }, leadingIcon && /*#__PURE__*/React.createElement(Box, null, leadingIcon), label)), trailingIcon && /*#__PURE__*/React.createElement(Box, null, trailingIcon));
};

export { LTCheckbox as default };
